document.addEventListener('DOMContentLoaded', function() {
  const variantSelectElement = document.querySelector('form[action="/cart/add"]'); // Greife auf das Produktformular zu

  if (variantSelectElement) {
    variantSelectElement.addEventListener('change', function(event) {
      const variantData = JSON.parse(document.querySelector('[data-selected-variant]').textContent); // Greife auf Variantendaten zu

      // SKU und Barcode aktualisieren
      document.getElementById('variant-sku').textContent = variantData.sku ? variantData.sku : 'SKU nicht verfügbar';
      document.getElementById('variant-barcode').textContent = variantData.barcode ? variantData.barcode : 'Barcode nicht verfügbar';
    });
  }
});